export const strategyData = [
    {
        icon: 'ecommerce-easy-icon',
        title: 'Easy Reach',
        description: "Reach your ideal customers at the moment they're pulling out their card, without spending thousands."
    },
    {
        icon: 'ecommerce-icon-boost',
        title: 'Boost Sales',
        description: "Optimize your marketing budget and boost your business with cross-promotions like never before."
    },
]